export default __webpack_public_path__ + "static/media/coffee.e2df70d2.png";